module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/recent-search-4cf8af826fed0f47dc46bcd4c1dc7fbc.svg";